/**
 * GoalAccount Model
 * Represents a separate tracking context (e.g., "Personal Goals", "Work Goals")
 */

export interface GoalAccount {
  id: string;                    // UUID v4
  name: string;                  // e.g., "Personal", "Work"
  themeColor?: string;           // Hex color for account theme (e.g., "#007AFF", "#34C759")
  createdAt: number;             // Unix timestamp (milliseconds)
  updatedAt: number;             // Unix timestamp (milliseconds)
  isDeleted: boolean;            // Soft delete flag
  syncEnabled: boolean;          // User setting: enable cross-device sync
  lastSyncTimestamp: number;     // Unix timestamp of last successful sync
}

/**
 * Predefined theme colors for accounts
 */
export const THEME_COLORS = [
  { name: 'Blue', color: '#007AFF' },
  { name: 'Green', color: '#34C759' },
  { name: 'Orange', color: '#FF9500' },
  { name: 'Red', color: '#FF3B30' },
  { name: 'Purple', color: '#AF52DE' },
  { name: 'Pink', color: '#FF2D55' },
  { name: 'Teal', color: '#5AC8FA' },
  { name: 'Indigo', color: '#5856D6' },
];

/**
 * Validation rules:
 * - name: Required, 1-50 characters, non-empty after trim
 * - Business rule: Account names should be unique (warn user on duplicate)
 * - Business rule: Must have at least one account (prevent deletion of last account)
 */
